// ─────────────────────────────────────────────────────────────────────────────
// 🔑 AN EXTRACTED VALUE, READABLE AT ANY DEPTH (Jesse, 2026-10-26 — the extracted-data panel, ReviewModule
// ExtractionCard). A nested object printed "[object Object]"; now: scalars as text (money where the key says so, Yes/No),
// an object as "key: value" lines, an array as a list (each item formatted the same way). Pure: no React.
// ─────────────────────────────────────────────────────────────────────────────

const MONEY_KEY = /amount|balance|pay|wage|income|rent|payment|gross|ytd|deposit|withdrawal|total|net/i;

/** "ending_balance" → "Ending Balance". */
export function labelOf(k) {
  return String(k).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

/** One scalar as text. */
export function scalarText(k, v) {
  if (v === null || v === undefined || v === '') return '—';
  if (typeof v === 'boolean') return v ? 'Yes' : 'No';
  if (typeof v === 'number' && MONEY_KEY.test(String(k || ''))) return `$${v.toLocaleString('en-US', { maximumFractionDigits: 2 })}`;
  return String(v);
}

/**
 * The value as lines to render: [{ depth, label, text, bullet }]. depth 0 for the top value's own lines.
 * An array of scalars → one bullet line each; an array of objects → each object's lines under a bullet; an object →
 * "Label: value" lines (nested objects indent). Never "[object Object]".
 */
export function extractionLines(k, v, depth = 0, maxDepth = 4) {
  if (v === null || v === undefined || v === '') return [];
  if (Array.isArray(v)) {
    if (!v.length) return [{ depth, label: null, text: 'None', bullet: false }];
    const out = [];
    v.forEach((item, i) => {
      if (item && typeof item === 'object' && depth < maxDepth) {
        const inner = extractionLines(k, item, depth + 1, maxDepth);
        out.push({ depth, label: null, text: `${i + 1}.`, bullet: true, group: true });
        out.push(...inner);
      } else out.push({ depth, label: null, text: item && typeof item === 'object' ? JSON.stringify(item) : scalarText(k, item), bullet: true });
    });
    return out;
  }
  if (typeof v === 'object') {
    const out = [];
    for (const [ck, cv] of Object.entries(v)) {
      if (cv === null || cv === undefined || cv === '') continue;
      if (cv && typeof cv === 'object' && depth < maxDepth) {
        out.push({ depth, label: labelOf(ck), text: '', bullet: false, group: true });
        out.push(...extractionLines(ck, cv, depth + 1, maxDepth));
      } else out.push({ depth, label: labelOf(ck), text: cv && typeof cv === 'object' ? JSON.stringify(cv) : scalarText(ck, cv), bullet: false });
    }
    return out;
  }
  return [{ depth, label: null, text: scalarText(k, v), bullet: false }];
}

/** True when the value needs the multi-line rendering. */
export const isNested = (v) => v !== null && typeof v === 'object';
